(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7701],{

/***/ 65988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ Accordion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var Accordion = function Accordion(_ref) {
  var accordionTitle = _ref.accordionTitle,
      children = _ref.children,
      contentsLength = _ref.contentsLength,
      _ref$isDefaultOpen = _ref.isDefaultOpen,
      isDefaultOpen = _ref$isDefaultOpen === void 0 ? false : _ref$isDefaultOpen;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isDefaultOpen),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      childHeight = _useState2[0],
      setChildHeight = _useState2[1];

  var childElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (childElement.current) {
      var _childElement$current;

      var height = (_childElement$current = childElement.current) === null || _childElement$current === void 0 ? void 0 : _childElement$current.clientHeight;
      setChildHeight(height);
    }
  }, []);

  var handleClick = function handleClick() {
    if (childElement.current) {
      setIsExpand(!isExpand);
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(AccordionTitle, {
      onClick: handleClick,
      children: [contentsLength > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Icon, {
        isExpand: isExpand
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Title, {
        children: accordionTitle
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_elements_Spacer__WEBPACK_IMPORTED_MODULE_2__/* .Spacer */ .L, {
      h: {
        sp: 10,
        pc: 18
      }
    }), contentsLength === 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(NoItemText, {
      children: "\u305F\u3060\u3044\u307E\u63B2\u8F09\u3059\u3079\u304D\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(AccordionItems, {
      isExpand: isExpand,
      childHeight: childHeight,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        ref: childElement,
        children: children
      })
    })]
  });
};
var AccordionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionTitle",
  componentId: "sc-1afnqmj-0"
})(["display:flex;align-items:center;gap:10px;&:hover{cursor:pointer;> h4{color:", ";}}@media screen and (max-width:1047px){align-items:flex-start;gap:6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
  displayName: "Accordion__Title",
  componentId: "sc-1afnqmj-1"
})(["font-size:24px;font-weight:bold;color:", ";line-height:33.6px;@media screen and (max-width:1047px){font-size:18px;line-height:23.4px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var NoItemText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__NoItemText",
  componentId: "sc-1afnqmj-2"
})(["font-size:16px;line-height:25.6px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle);
var AccordionItems = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Accordion__AccordionItems",
  componentId: "sc-1afnqmj-3"
})(["height:", ";opacity:", ";transition:height 0.2s linear,opacity 0.5s ease-in;overflow:hidden;"], function (_ref2) {
  var isExpand = _ref2.isExpand,
      childHeight = _ref2.childHeight;
  return isExpand ? "".concat(childHeight, "px") : '0px';
}, function (_ref3) {
  var isExpand = _ref3.isExpand;
  return isExpand ? 1 : 0;
});
var Icon = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Accordion__Icon",
  componentId: "sc-1afnqmj-4"
})(["transition:all 0.25s ease;overflow:hidden;position:relative;padding-top:2px;padding-right:10px;width:40px;height:40px;&::before,&::after{content:'';display:inline-block;width:30px;height:4px;position:absolute;top:50%;background-image:url('/images/accordion.png');}&::after{transform:rotate(90deg);transition:transform 0.4s ease;}", " @media screen and (max-width:1047px){padding-top:7px;padding-right:16px;width:16px;height:23px;&::before,&::after{width:16px;height:2.13px;}}"], function (_ref4) {
  var isExpand = _ref4.isExpand;
  return isExpand ? (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["&::after{transform:rotate(0);}"]) : '';
});

/***/ }),

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 52143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97749);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-106wc0z-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-106wc0z-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 24604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PDFItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16645);
/* harmony import */ var _components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97071);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Time, {
      dateTime: date,
      children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_3__/* .formatDate */ .p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Icon, {
      size: "small"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].time.withConfig */ .ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-12039hs-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-12039hs-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.lightBlue */ .r.colors.lightBlue);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-12039hs-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_components_elements_Icon_PDF__WEBPACK_IMPORTED_MODULE_1__/* .PDFIcon */ .H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-12039hs-3"
})(["flex-shrink:0;"]);

/***/ }),

/***/ 16653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ PDFList; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var _PDFItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24604);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFList = function PDFList(_ref) {
  var pdfList = _ref.pdfList;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
    children: pdfList.map(function (pdf) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Item, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_PDFItem__WEBPACK_IMPORTED_MODULE_2__/* .PDFItem */ .G, _objectSpread({}, pdf))
      }, pdf.id);
    })
  });
};
var Item = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "PDFList__Item",
  componentId: "sc-mppgtj-0"
})(["display:flex;align-items:center;:not(:last-child){border-bottom:1px solid ", ";}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue);

/***/ }),

/***/ 49745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ MonthlySalesPDF; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _components_elements_Accordion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65988);
/* harmony import */ var _components_layouts_Ir_PDFList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var MonthlySalesPDF = function MonthlySalesPDF(_ref) {
  var yearsPdf = _ref.yearsPdf;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Section, {
      children: yearsPdf.map(function (value, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_Accordion__WEBPACK_IMPORTED_MODULE_0__/* .Accordion */ .U, {
            accordionTitle: value.accordionTitle,
            contentsLength: value.accordionItems.length,
            isDefaultOpen: value.isDefaultOpen,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_layouts_Ir_PDFList__WEBPACK_IMPORTED_MODULE_1__/* .PDFList */ .T, {
              pdfList: value.accordionItems
            })
          })
        }, "".concat(index).concat(value.accordionTitle));
      })
    })
  });
};
var Section = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Pdffiles__Section",
  componentId: "sc-161uj94-0"
})(["display:flex;flex-direction:column;gap:50px;h4{margin-bottom:0px !important;}"]);

/***/ }),

/***/ 26639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55548);
/* harmony import */ var _components_layouts_Company_CompanyLinks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52143);
/* harmony import */ var _components_layouts_Head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22978);
/* harmony import */ var _components_layouts_Ir_Pdffiles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49745);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);
// pages/retail-investor/Topics-highlight.tsx










var TopicsCocotoraPage = function TopicsCocotoraPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(CompanyMain, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layouts_Company_CompanyLinks__WEBPACK_IMPORTED_MODULE_2__/* .CompanyLinks */ .b, {
        padding: {
          pc: '0 0',
          sp: '0 0'
        }
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (TopicsCocotoraPage);

TopicsCocotoraPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '個人投資家の皆様へ',
    path: '/ir/investor/'
  }, {
    name: 'ココ見てトライアル2025',
    path: ''
  }];
  var yearsPdf = [{
    accordionTitle: '2024年6月期（2023年7月1日〜2024年6月30日）',
    accordionItems: [{
      id: '',
      fileName: '2024年６月期 TRIALレポート',
      filePath: 'https://report-k.pdcp.jp/141A/202409/a/'
    }],
    isDefaultOpen: true
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layouts_Head__WEBPACK_IMPORTED_MODULE_3__/* .Head */ .F, {
      title: "\u4F01\u696D\u60C5\u5831",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u4F01\u696D\u60C5\u5831\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'company/'
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layout__WEBPACK_IMPORTED_MODULE_1__/* .TitleLayout */ .$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSection, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsTitleBuild, {
          style: {
            marginTop: '20px'
          },
          children: "\u682A\u5F0F\u4F1A\u793E\u897F\u53CB"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeyuTit, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeyuTitLogo, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
              src: "/images/topics_cocotora_40.png"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeyuTitRemark, {
            children: ["\u897F\u53CB\u306E\u4F7F\u547D: ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
              children: "\uFF62\u897F\u53CB\u304C\u8EAB\u8FD1\u306B\u3042\u308B\u3057\u3042\u308F\u305B\uFF63\u3092\u3081\u3056\u3057\u3066"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(Seiyu, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeft, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftCompany, {
              children: "\u682A \u5F0F \u4F1A \u793E \u897F \u53CB"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                style: {
                  overflow: 'hidden'
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoCompany, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoLine, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineKey, {
                      children: "\u8A2D \u7ACB"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineValue, {
                      children: "1963\u5E744\u6708"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoLine, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineKey, {
                      children: "\u8CC7\u672C\u91D1"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineValue, {
                      children: "1\u5104\u5186"
                    })]
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuRightInfoMember, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoLine, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineKey, {
                      children: "\u672C \u793E"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineValue, {
                      children: "\u6771\u4EAC\u90FD\u6B66\u8535\u91CE\u5E02\u5409\u7965\u5BFA"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoLine, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineKey, {
                      children: "\u5F93\u696D\u54E1\u6570"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoTwoLineValue, {
                      children: ["\u793E\u54E1 2,771\u540D", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u81E8\u6642\u96C7\u7528\u8005 16,229\u540D"]
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoLineBottom, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineKey, {
                  children: "\u5F79 \u54E1"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuLeftInfoLineValue, {
                  children: "\u4EE3\u8868\u53D6\u7DE0\u5F79\u793E\u9577 \u6962\u6728\u91CE \u4EC1\u53F8"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuLeftInfoRemark, {
                children: [" \u203B\u793E\u54E1\uFF1A", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                  children: "\u30D5\u30EB\u30BF\u30A4\u30E0\u30EF\u30FC\u30AB\u30FC\u3092"
                }), "\u6307", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                  children: "\u3059"
                }), " \u203B2025\u5E74\uFF16\u670816\u65E5\u6642\u70B9"]
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapStore, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMap, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapInfo, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                    src: "/images/topics_cocotora_1.png"
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemark, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkLogo, {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                        src: "/images/topics_cocotora_41.png"
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkLine, {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkList, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListKey, {
                          children: "\u95A2 \u6771"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListValue, {
                          children: "135\u5E97\u8217"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkList, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListKey, {
                          children: "\u4E2D \u90E8"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListValue, {
                          children: "72\u5E97\u8217"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkList, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListKey, {
                          children: "\u95A2 \u897F"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListValue, {
                          children: "19\u5E97\u8217"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkList, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListKey, {
                          children: "\u6771 \u5317"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkListValue, {
                          children: "19\u5E97\u8217"
                        })]
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuMapRemarkTotal, {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkTotalKey, {
                        children: "\u5408 \u8A08"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuMapRemarkTotalValue, {
                        children: "245\u5E97\u8217"
                      })]
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStore, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreList, {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListTit, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListLeft, {
                      children: "\u897F\u53CB"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListRight, {
                      children: "LIVIN"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListImg, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListTitLeft, {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                        src: "/images/topics_cocotora_2.png"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListImgRemark, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                          children: "\u30A2\u30A4\u30C6\u30E0\u6570"
                        }), "\u7D04", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                          children: "\uFF16"
                        }), "\uFF5E", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                          children: "\uFF17"
                        }), "\u4E07\u70B9"]
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListTitRight, {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                        src: "/images/topics_cocotora_3.png"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListImgRemark, {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
                          children: "\u30A2\u30A4\u30C6\u30E0\u6570"
                        }), "\u7D04", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                          children: "10"
                        }), "\u4E07\u70B9"]
                      })]
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListInfo, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListLeft, {
                      children: "240\u5E97\u8217"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListRight, {
                      children: "5\u5E97\u8217"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListArea, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListLeft, {
                      children: "\u7D042,000\u33A1"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListRight, {
                      children: "\u7D0410,000\u33A1"
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuStoreListInfo, {
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListLeft, {
                      children: "\u90FD\u5E02\u578B"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuStoreListRight, {
                      children: "\u90FD\u5E02\u578B/\u90CA\u5916\u578B"
                    })]
                  })]
                })
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuRight, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightTit, {
              children: "\u897F\u53CB\u306E\u7279\u5FB4\uFF14\u9078\uFF01"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuRightBorder, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelect, {
                children: "\u751F\u6D3B\u306B\u6839\u3056\u3057\u305F\u5E97\u8217\u5C55\u958B"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelectRemark, {
                children: "\u95A2\u6771\u570F\u3092\u4E2D\u5FC3\u306B\u3001\u99C5\u524D\u30FB\u4F4F\u5B85\u7ACB\u5730\u304C\u591A\u304F\u3001\u65E5\u5E38\u4F7F\u3044\u306B\u4FBF\u5229\u306A\u5E97\u8217\u7DB2\u3092\u5C55\u958B\u3002\u7686\u3055\u307E\u306E\u66AE\u3089\u3057\u306B\u5BC4\u308A\u6DFB\u3046\u5B58\u5728\u3002"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelect, {
                children: "\u3044\u305F\u3060\u3044\u305F\u58F0\u3092\u5546\u54C1\u3065\u304F\u308A\u306B"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelectRemark, {
                children: "\u30D7\u30E9\u30A4\u3079\u30FC\u30C8\u30D6\u30E9\u30F3\u30C9\u300C\u307F\u306A\u3055\u307E\u306E\u304A\u58A8\u4ED8\u304D\u300D\u3067\u306F\u3001\u7B2C\u4E09\u8005\u6A5F\u95A2\u306B\u3088\u308B\u6D88\u8CBB\u8005\u30C6\u30B9\u30C8\u306B\u3088\u308A\u304A\u5BA2\u3055\u307E\u306E\u58F0\u3092\u53CD\u6620\u3057\u305F\u5546\u54C1\u958B\u767A\u3092\u5B9F\u73FE\u3002"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelect, {
                children: "\u30E6\u30FC\u30B6\u30FC\u76EE\u7DDA\u306E\u30CD\u30C3\u30C8\u30B9\u30FC\u30D1\u30FC\u5148\u9032\u4F01\u696D"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelectRemark, {
                children: "\u65E5\u672C\u3067\u521D\u3081\u3066\u30CD\u30C3\u30C8\u30B9\u30FC\u30D1\u30FC\u30B5\u30FC\u30D3\u30B9\u3092\u5C55\u958B\u3057\u305F\u5927\u624B\u30B9\u30FC\u30D1\u30FC\u3068\u3057\u3066\u3001\u66F4\u306A\u308B\u5229\u4FBF\u6027\u63D0\u4F9B\u306B\u5411\u3051\u3066\u5C55\u958B\u30A8\u30EA\u30A2\u62E1\u5927\u4E2D\u3002"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuRightSelect, {
                children: "\u52D5\u304D\u7D9A\u3051\u308B\u9032\u5316\u4F01\u696D"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(SeiyuRightSelectRemark, {
                children: ["\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u3068\u306E\u878D\u5408\u306B\u3088\u308A\u3001\u30C7\u30B8\u30BF\u30EB\u5316\u3092\u63A8\u9032\u3002", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u6B21\u4E16\u4EE3\u306B\u5411\u3051\u305F\u65B0\u305F\u306A\u6311\u6226\u3092\u901A\u3058\u3066\u5E38\u306B\u9032\u5316\u3092\u7D99\u7D9A\u3002"]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                style: {
                  height: '15px'
                }
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(SeiyuDevelopment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
            src: "/images/topics_cocotora_4.png"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u300C\u307F\u306A\u3055\u307E\u306E\u304A\u58A8\u4ED8\u304D\u300D\u5546\u54C1\u958B\u767A\u30B3\u30F3\u30BB\u30D7\u30C8"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsScription, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            style: {
              color: '#2F5597'
            },
            children: "\u897F\u53CB\u306E\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30FB\u30D6\u30E9\u30F3\u30C9\u300C\u307F\u306A\u3055\u307E\u306E\u304A\u58A8\u4ED8\u304D\u300D"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSales, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_13.png"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSalesListRemark, {
            style: {
              width: 'calc(100% - 380px)'
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u304A\u3044\u3057\u3044\u3001\u4F7F\u3044\u3084\u3059\u3044\u306E\u58F0\u3001\u7D9A\u3005\u3002"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u30B7\u30F3\u30DC\u30EB\u30DE\u30FC\u30AF\u306E\u4E8C\u91CD\u4E38\u306F\u3001\u307F\u306A\u3055\u307E\u304B\u3089\u306E\u304A\u58A8\u4ED8\u304D\u306E\u5370\u3002"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelop, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopLeft, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsDevelopLeftTitle, {
              children: "\u958B \u767A \u624B \u6CD5"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopLeftInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopLeftRemark, {
                children: ["\u7B2C\u4E09\u8005\u6A5F\u95A2\u306B\u3088\u308B\u53B3\u6B63\u306A\u6D88\u8CBB\u8005\u30C6\u30B9\u30C8\u3067\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                  children: "80%\u4EE5\u4E0A\u306E\u652F\u6301\u7387\u3092\u7372\u5F97\u3057\u305F"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u300C\u826F\u3044\u306E\u306B\u3001\u5B89\u3044\u300D\u5546\u54C1\u3060\u3051\u3092\u63D0\u4F9B"]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsDevelopLeftImg, {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_12.png"
                })
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopRight, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsDevelopRightTit, {
              children: "\u6CE8\u76EE\u5546\u54C1\u30AB\u30BF\u30ED\u30B0"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopRightInfo, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopRightInfoFlex, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_7.png"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                    children: "\u25CF"
                  }), "\u672C\u683C\u30EC\u30C8\u30EB\u30C8\u30AB\u30EC\u30FC\u30B7\u30EA\u30FC\u30BA"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_9.png"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                    children: "\u25CF"
                  }), "On the \u3054\u306F\u3093\u30B7\u30EA\u30FC\u30BA"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_11.png"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsDevelopRightInfoFlex, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_8.png"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                    children: "\u25CF"
                  }), "\u539A\u5207\u308A\u30C1\u30C3\u30D7\u30B9\u30B7\u30EA\u30FC\u30BA"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_10.png"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                    children: "\u25CF"
                  }), "\u51B7\u51CD\u98DF\u54C1"]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_6.png"
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsScription, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
            children: ["\u300C\u307F\u306A\u3055\u307E\u306E\u304A\u58A8\u4ED8\u304D\u300D\u306E\u30B3\u30F3\u30BB\u30D5\u309A\u30C8\u3084\u5546\u54C1\u306E\u8A73\u7D30\u306F", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              href: "https://www.seiyu.co.jp/pb/mo/",
              target: "_blank",
              rel: "noopener noreferrer",
              children: "\u3053\u3061\u3089"
            }), "\u3092\u3053\u3099\u89A7\u304F\u305F\u3099\u3055\u3044!"]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsTitlePB, {
          children: ["\u304A\u5BA2\u3055\u307E\u306B\u611B\u3055\u308C\u308B\u5546\u54C1\u304C\u751F\u307E\u308C\u308B\u307E\u3067", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "PB\u6226\u7565"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u5546\u54C1\u958B\u767A\u30B3\u30F3\u30BB\u30D7\u30C8"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsScription, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "IT\u3068\u8077\u4EBA\u306E\u7D4C\u9A13\u77E5\u3067\u4FA1\u683C\u4EE5\u4E0A\u306E\u4FA1\u5024\u3092\u4F1D\u3048\u308B\u300E\u304A\u3044\u3057\u3055\u300F\u3092\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSales, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_15.png"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSalesListRemark, {
            style: {
              width: 'calc(100% - 380px)'
            },
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306F\u300C\u6599\u7406\u306E\u8077\u4EBA\u54C1\u8CEA\u3092\u304A\u5C4A\u3051\u3057\u305F\u3044\u300D\u3068\u3044\u3046\u60F3\u3044\u3092\u8FBC\u3081\u305F\u300C\u3053\u306F\u304F\u672C\u8217\u300D\u30D6\u30E9\u30F3\u30C9\u306E\u3082\u3068\u3001\u5473\u306F\u3082\u3061\u308D\u3093\u3001\u98DF\u6750\u3001\u4FA1\u683C\u3001\u3059\u3079\u3066\u306B\u611F\u52D5\u3092\u547C\u3076\u300C\u98DF\u3065\u304F\u308A\u300D\u306B\u53D6\u308A\u7D44\u3093\u3067\u3044\u307E\u3059\u3002"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u4FA1\u683C\u4EE5\u4E0A\u306E\u4FA1\u5024\u3092\u5B9F\u611F\u3057\u3066\u3044\u305F\u3060\u3051\u308B\u300C\u304A\u3044\u3057\u3055\u300D\u3092\u3001\u6BCE\u65E5\u306E\u304A\u5BA2\u3055\u307E\u306E\u98DF\u4E8B\u306B\u3002"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u305D\u306E\u300C\u304A\u3044\u3057\u3055\u300D\u306F\u3001\u7ACB\u3061\u6B62\u307E\u308B\u3053\u3068\u306A\u304F\u3001\u9032\u5316\u3092\u3064\u3065\u3051\u307E\u3059\u3002"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          style: {
            marginTop: '30px',
            marginBottom: '20px'
          },
          src: "/images/topics_cocotora_14.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u304B\u3064\u91CD\u5C02\u7528\u8ABF\u7406\u30DE\u30B7\u30F3\u306E\u72EC\u81EA\u958B\u767A"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsEcharts, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsEchartsList, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsEchartsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_16.png"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsEchartsListTit, {
              children: "\u8077\u4EBA\u306E\u7E4A\u7D30\u306A\u6280\u8853\u30FB\u30EC\u30B7\u30D4"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsEchartsList, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsEchartsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_17.png"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsEchartsListTit, {
              children: "\u30D7\u30ED\u306E\u5473\u3092\u30C7\u30FC\u30BF\u5316"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsEchartsList, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsEchartsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_18.png"
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsEchartsListTit, {
              children: ["\u30C7\u30FC\u30BF\u5316\u3055\u308C\u305F\u6280\u8853\u3092\u5FE0\u5B9F\u306B", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u518D\u73FE\u3067\u304D\u308B\u6A5F\u68B0\u3092\u72EC\u81EA\u958B\u767A"]
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsScription, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
            style: {
              color: '#2F5597'
            },
            children: ["IT\u3068\u8077\u4EBA\u306E\u7D4C\u9A13\u77E5\u3067\u3001\u5C02\u7528\u306E\u8ABF\u7406\u30DE\u30B7\u30F3\u3092\u72EC\u81EA\u958B\u767A\u3059\u308B\u3053\u3068\u3067\u3001", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("br", {}), "\u304A\u5BA2\u3055\u307E\u306B\u652F\u6301\u3055\u308C\u3066\u3044\u308B\u5473\u3092\u65E5\u672C\u5168\u56FD\u3067\u518D\u73FE\u3057\u3001\u304A\u6C42\u3081\u3084\u3059\u3044\u4FA1\u683C\u3067\u63D0\u4F9B"]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSales, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                src: "/images/topics_cocotora_19.png"
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSalesListRemark, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListRemarkTit, {
              children: "\u5E74\u9593\u7D041,000\u4E07\u98DF\u3092\u8CA9\u58F2\uFF01"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
              children: "\u7D20\u6750\u306B\u3082\u3053\u3060\u308F\u308A\u3055\u3089\u306B\u9032\u5316\uFF01"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u5927\u624B\u98DF\u54C1\u52A0\u5DE5\u30E1\u30FC\u30AB\u30FC\u3068\u30B3\u30E9\u30DC\u3057\u3001\u304A\u8089\u306E\u91CF\u3092\u5897\u91CF\u3057\u3001\u98DF\u3079\u5FDC\u3048\u304C\u30A2\u30C3\u30D7"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
              children: "\u5730\u57DF\u306E\u5473\u306B\u5BC6\u7740\uFF01"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u6771\u3067\u306F\u6FC3\u53E3\u91A4\u6CB9\u3001\u897F\u3067\u306F\u8584\u53E3\u91A4\u6CB9\u3092\u4F7F\u3046\u306A\u3069\u3001\u5404\u5730\u57DF\u306E\u7686\u3055\u307E\u306B\u5BC4\u308A\u6DFB\u3063\u305F\u5473\u4ED8\u3051"
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u5354\u696D\u3067\u751F\u307E\u308C\u305F\u3053\u3060\u308F\u308A\u5546\u54C1"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsGoods, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/22319/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_25.png"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/20871/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_26.png"
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsGoods, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/14323/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_27.png"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/21051/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_28.png"
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsGoods, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/13366/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_29.png"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsGoodsListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/detail/19477/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_30.png"
                })
              })
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsSales, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesList, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListImg, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                href: "https://www.trial-net.co.jp/mag/",
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
                  src: "/images/topics_cocotora_31.png"
                })
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsSalesListRemark, {
            style: {
              width: 'calc(100% - 380px)'
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
              children: "\u305D\u306E\u4ED6\u3001Web\u30DE\u30AC\u30B8\u30F3\u300C\u304F\u3089\u3057\u30C8\u30E9\u30A4\u300D\u306B\u3066\u3001\u304A\u3059\u3059\u3081\u306E\u5546\u54C1\u3084\u751F\u6D3B\u306B\u5F79\u7ACB\u3064\u60C5\u5831\u3092\u767A\u4FE1\u3057\u3066\u304A\u308A\u307E\u3059\u306E\u3067\u3001\u662F\u975E\u3054\u89A7\u304F\u3060\u3055\u3044\uFF01"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsTitleBuild, {
          children: "\u30EA\u30C6\u30FC\u30EB\u30C6\u30C3\u30AF\u3092\u6D3B\u7528\u3057\u305F\u6D41\u901A\u30A8\u30B3\u30B7\u30B9\u30C6\u30E0\u306E\u69CB\u7BC9"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsScription, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u304C\u53D6\u5F97\u3057\u3001\u6574\u7406\u30FB\u5206\u6790\u3057\u305F\u30C7\u30FC\u30BF\u3092\u30E1\u30FC\u30AB\u30FC\u3001\u5378\u3001\u7269\u6D41\u3001\u5C0F\u58F2\u9593\u3067\u30B7\u30FC\u30E0\u30EC\u30B9\u306B\u5171\u6709\u3059\u308B\u3053\u3068\u3067\u3001\u696D\u754C\u5168\u4F53\u306E\u6D41\u901A\u30A8\u30B3\u30B7\u30B9\u30C6\u30E0\u3092\u69CB\u7BC9"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          style: {
            marginTop: '30px'
          },
          src: "/images/topics_cocotora_20.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImgRemark, {
          children: "\u203B \u5F53\u793E\u306E\u5206\u6790\u306B\u57FA\u3065\u304F\u30A4\u30E1\u30FC\u30B8\u56F3"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          style: {
            marginTop: '45px'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u5354\u696D\u3067\u76EE\u6307\u3059\u6D41\u901A\u60C5\u5831\u9769\u547D"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          style: {
            marginTop: '35px'
          },
          src: "/images/topics_cocotora_21.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          src: "/images/topics_cocotora_22.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          src: "/images/topics_cocotora_23.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsScription, {
          style: {
            marginTop: '45px'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            children: "\u25CF"
          }), "\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306E\u300C\u30E0\u30C0\uFF65\u30E0\u30E9\uFF65\u30E0\u30EA\u300D\u306E\u89E3\u6D88\u306B\u3088\u308B\u696D\u754C\u5909\u9769"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          style: {
            marginTop: '30px'
          },
          src: "/images/topics_cocotora_24.png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(TopicsImg24Remark, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfo, {
            children: "*1 \u7D4C\u6E08\u7523\u696D\u7701\u300C\u5546\u696D\u52D5\u614B\u7D71\u8A08\u300D2024\u5E74\u5EA6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfo, {
            children: "*2 \u5F53\u793E\u306F\u3001\u6D41\u901A\u5C0F\u58F2\u696D\u754C\u306B\u306F\u591A\u304F\u306E\u300C\u30E0\u30C0\uFF65\u30E0\u30E9\uFF65\u30E0\u30EA\u300D\u304C\u5B58\u5728\u3057\u3066\u3044\u308B\u3068\u8003\u3048\u3066\u304A\u308A\u307E\u3059\u3002\u5F53\u793E\u306F\u3001\u6B20\u54C1\uFF0F\u30ED\u30B9\u3001R&D\u3001\u652F\u5E97\uFF0F\u5546\u8AC7\u3001\u5E83\u544A\u3001\u30EA\u30D9\u30FC\u30C8\u306B\u4FC2\u308B\u30B3\u30B9\u30C8\u3092\u5E83\u304F\u5408\u7B97\u3057\u305F\u7DCF\u984D\u306F\u7D0440\u5146\u5186\u306B\u306E\u307C\u308B\u3068\u8A66\u7B97\u3057\u3066\u304A\u308A\u3001\u56FD\u5185\u306E\u6D41\u901A\u5C0F\u58F2\u696D\u306E\u58F2\u4E0A\u9AD8165\u5146\u5186\u3068\u306E\u5BFE\u6BD4\u3067\u3082\u3001\u304B\u304B\u308B\u300C\u30E0\u30C0\uFF65\u30E0\u30E9\uFF65\u30E0\u30EA\u300D\u306E\u5927\u304D\u3055\u304C\u898B\u3066\u53D6\u308C\u308B\u3068\u8003\u3048\u3066\u304A\u308A\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FB\u6B20\u54C1/\u30ED\u30B9\uFF1A\u98F2\u98DF\u6599\u54C1\u696D\u754C\u306E\u98DF\u54C1\u5EC3\u68C4\u984D\u3001\u8CC7\u7523\u30ED\u30B9\uFF08\u4E07\u5F15\u30FB\u4E0D\u6B63\u30FB\u7BA1\u7406\u30DF\u30B9\u306B\u3088\u308B\u640D\u5931\uFF09\u53CA\u3073\u6A5F\u4F1A\u30ED\u30B9\uFF08\u6B20\u54C1\u306B\u3088\u308B\u58F2\u4E0A\u9AD8\u306E\u6E1B\u5C11\uFF09\u306E\u5408\u8A08\u3002\u98DF\u54C1\u5EC3\u68C4\u984D\u306F\u7D4C\u6E08\u7523\u696D\u7701\u300C\u5546\u696D\u52D5\u614B\u7D71\u8A08\u300D\uFF082024\u5E74\u5EA6\uFF09\u53CA\u3073\u5168\u56FD\u30B9\u30FC\u30D1\u30FC\u30DE\u30FC\u30B1\u30C3\u30C8\u5354\u4F1A\u300C\u30B9\u30FC\u30D1\u30FC\u30DE\u30FC\u30B1\u30C3\u30C8\u5E74\u6B21\u7D71\u8A08\u8ABF\u67FB\u5831\u544A\u66F8\u300D\uFF082024\u5E7410\u6708\uFF09\u304B\u3089\u63A8\u8A08\u3001\u8CC7\u7523\u30ED\u30B9\u306F\u7D4C\u6E08\u7523\u696D\u7701\u300C\u5546\u696D\u52D5\u614B\u7D71\u8A08\u300D\uFF082024\u5E74\u5EA6\uFF09\u53CA\u3073\u5168\u56FD\u4E07\u5F15\u72AF\u7F6A\u9632\u6B62\u6A5F\u69CB\u300C\u7B2C14\u56DE\u5168\u56FD\u5C0F\u58F2\u696D\u4E0D\u660E\u30ED\u30B9\u30FB\u5E97\u8217\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u5B9F\u614B\u8ABF\u67FB\u5206\u6790\u5831\u544A\u66F8\u300D\uFF082024\u5E74\uFF14\u6708\uFF09\u304B\u3089\u63A8\u8A08\uFF64\u6A5F\u4F1A\u30ED\u30B9\u306F\u7D4C\u6E08\u7523\u696D\u7701\u300C\u5546\u696D\u52D5\u614B\u7D71\u8A08\u300D\uFF082024\u5E74\u5EA6\uFF09\u307B\u304B\u53CA\u3073Daniel Corsten, Thomas Gruen \u300COn Shelf Availability: An Examination of the Extent, the Causes, and the Efforts to Address Retail Out-of-Stocks\u300D(2005) \uFF08\u6B20\u54C1\u306B\u3088\u308B\u58F2\u4E0A\u9AD8\u306E\u6E1B\u5C11\u7387\uFF08\u4E16\u754C\u5E73\u5747\uFF09\uFF09 \u304B\u3089\u63A8\u8A08"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FBR&D\uFF1A\u98DF\u54C1\u98F2\u6599\u30E1\u30FC\u30AB\u30FC\u3001\u6D88\u8CBB\u8CA1\u30E1\u30FC\u30AB\u30FC\u53CA\u3073\u8863\u98DF\u95A2\u9023\u306E\u5378\u30FB\u5C0F\u58F2\u306B\u4FC2\u308B\u7814\u7A76\u958B\u767A\u8CBB\u53CA\u3073\u7814\u7A76\u958B\u767A\u90E8\u9580\u306E\u4EBA\u4EF6\u8CBB\u7DCF\u984D\u306E\u5408\u8A08\u3002\u98DF\u54C1\u98F2\u6599\u30FB\u6D88\u8CBB\u8CA1\u30E1\u30FC\u30AB\u30FC\u306B\u4FC2\u308B\u7814\u7A76\u958B\u767A\u8CBB\u306F\u4E0A\u5834\u4F01\u696D\u306E\u958B\u793A\u30C7\u30FC\u30BF\uFF08\u51FA\u6240\uFF1AQuick\uFF09\u306B\u304A\u3051\u308B\u300C\u7814\u7A76\u958B\u767A\u8CBB\u300D\u3092\u96C6\u8A08"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u3057\u3066\u63A8\u8A08\u3001\u8863\u98DF\u95A2\u9023\u306E\u5378\u30FB\u5C0F\u58F2\u306B\u4FC2\u308B\u7814\u7A76\u958B\u767A\u8CBB\u306F\u7D4C\u6E08\u7523\u696D\u7701\u300C\u4F01\u696D\u6D3B\u52D5\u57FA\u672C\u8ABF\u67FB\u300D\uFF082023\u5E74\u5EA6\uFF09\u304B\u3089\u63A8\u8A08\u3002\u4EBA\u4EF6\u8CBB\u7DCF\u984D\u306F\u7D4C\u6E08\u7523\u696D\u7701\u300C\u4F01\u696D\u6D3B\u52D5\u57FA\u672C\u8ABF\u67FB\u300D\uFF082023\u5E74\u5EA6\uFF09\u3092\u57FA\u306BR&D\u90E8\u9580\u306E\u63A8\u5B9A\u4EBA\u54E1\u6570\xD7\u4E00\u4EBA\u5F53\u305F\u308A\u63A8\u5B9A\u4EBA\u4EF6\u8CBB\u7DCF\u984D\u3067\u8A66\u7B97"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FB\u652F\u5E97/\u5546\u8AC7\uFF1A\u65E5\u672C\u5168\u56FD\u306B\u652F\u5E97\u3092\u69CB\u3048\u3001\u55B6\u696D\u62E0\u70B9\u304C\u70B9\u5728\u3059\u308B\u3053\u3068\u53CA\u3073\u500B\u5225\u5546\u8AC7\u3092\u884C\u3046\u3053\u3068\u306B\u3088\u308B\u975E\u52B9\u7387\u6027\u3092\u6307\u3059\u3002\u7D4C\u6E08\u7523\u696D\u7701\u300C\u5546\u696D\u52D5\u614B\u7D71\u8A08\u300D\uFF082024\u5E74\u5EA6\uFF09\u53CA\u3073\u65E5\u672C\u30ED\u30B8\u30B9\u30C6\u30A3\u30AF\u30B9\u30B7\u30B9\u30C6\u30E0\u5354\u4F1A\u300C\u7269\u6D41\u30B3\u30B9\u30C8\u8ABF\u67FB\u300D\uFF082024\u5E74\u5EA6\uFF09\u7B49\u304B\u3089\u63A8\u8A08"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FB\u5E83\u544A\uFF1A\u65E5\u672C\u306E\u7DCF\u5E83\u544A\u8CBB\u3067\u3042\u308A\u3001\u96FB\u901A\uFF622024\u5E74\u65E5\u672C\u306E\u5E83\u544A\u8CBB\uFF63\u306B\u57FA\u3065\u304F"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FB\u30EA\u30D9\u30FC\u30C8\uFF1A\u6D88\u8CBB\u8CA1\u30E1\u30FC\u30AB\u30FC\u306E\u8CA9\u4FC3\u8CBB\u7528\u306E\u5408\u8A08\u3067\u3042\u308A\u3001\u7D4C\u6E08\u7523\u696D\u7701\u300C\u5DE5\u696D\u7D71\u8A08\u8ABF\u67FB\u300D\uFF082020\u5E74\u5EA6\uFF09\u53CA\u3073\u30C7\u30ED\u30A4\u30C8\u30C8\u30FC\u30DE\u30C4\u300C\u6D88\u8CBB\u8CA1\u30E1\u30FC\u30AB\u30FC\u306B\u304A\u3051\u308B\u8CA9\u4FC3\u8CBB\u7528\u6700\u9069\u5316:\u30BC\u30ED\u30D9\u30FC\u30B9\u4E88\u7B97\u3092\u6D3B\u7528\u3057\u305F\u6700\u9069\u5316\u30A2\u30D7\u30ED\u30FC\u30C1\u300D\u304B\u3089\u63A8\u8A08"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(TopicsImg24RemarkInfoTxt, {
            children: "\u30FBOne to One\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0: \u6D88\u8CBB\u8005\u500B\u5225\u306E\u8CFC\u8CB7\u50BE\u5411\u53CA\u3073\u5C5E\u6027\u7B49\u304B\u3089\u30CB\u30FC\u30BA\u3092\u8AAD\u307F\u53D6\u308A\u3001\u500B\u3005\u306B\u5BFE\u3057\u3066\u6700\u9069\u306A\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u884C\u3046\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u6D3B\u52D5"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_layouts_Ir_Pdffiles__WEBPACK_IMPORTED_MODULE_4__/* .MonthlySalesPDF */ .s, {
          yearsPdf: yearsPdf
        })]
      })
    })]
  });
};

var CompanyMain = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__CompanyMain",
  componentId: "sc-10alucx-0"
})(["width:1040px;margin:0 auto;padding:98px 0 130px;@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var TopicsSection = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSection",
  componentId: "sc-10alucx-1"
})(["width:1040px;margin:0 auto;padding:30px 0 130px;img{width:100%;}@media screen and (max-width:1047px){width:100%;padding:40px 20px 70px;}"]);
var TopicsTitleBuild = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "topics-cocotora2025__TopicsTitleBuild",
  componentId: "sc-10alucx-2"
})(["width:100%;padding:15px 10px;font-size:32px;font-weight:bold;color:#FFF;margin-top:150px;background:", ";@media screen and (max-width:1047px){font-size:17px;line-height:19px;margin-top:100px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsTitlePB = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsTitlePB",
  componentId: "sc-10alucx-3"
})(["width:100%;min-height:135px;line-height:58px;font-size:32px;font-weight:bold;text-indent:10px;color:#FFF;margin-top:150px;background:", ";span{font-size:46px;margin-left:15px;}@media screen and (max-width:1047px){font-size:17px;height:40px;line-height:38px;min-height:90px;margin-top:100px;span{font-size:30px;margin-left:10px;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsScription = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsScription",
  componentId: "sc-10alucx-4"
})(["margin-top:30px;font-size:26px;line-height:34px;font-weight:bold;overflow:hidden;span{margin-right:8px;}p{margin-top:10px;font-size:20px;letter-spacing:1px;}a{color:", ";text-decoration:underline;}@media screen and (max-width:1047px){font-size:16px;line-height:23px;margin-top:12px;span{margin-right:5px;}p{font-size:16px;line-height:26px;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsEcharts = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsEcharts",
  componentId: "sc-10alucx-5"
})(["display:flex;width:100%;@media screen and (max-width:1040px){display:block;}"]);
var TopicsEchartsList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsEchartsList",
  componentId: "sc-10alucx-6"
})(["flex:1;"]);
var TopicsEchartsListTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsEchartsListTit",
  componentId: "sc-10alucx-7"
})(["line-height:24px;font-size:20px;font-weight:bold;height:70px;text-align:center;@media screen and (max-width:1040px){font-size:14px;line-height:20px;height:40px;}"]);
var TopicsEchartsListImg = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsEchartsListImg",
  componentId: "sc-10alucx-8"
})(["max-width:340px;width:100%;margin:0 auto;"]);
var TopicsGoods = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsGoods",
  componentId: "sc-10alucx-9"
})(["display:flex;gap:40px;width:100%;@media screen and (max-width:1040px){display:block;}"]);
var TopicsGoodsList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsGoodsList",
  componentId: "sc-10alucx-10"
})(["flex:1;"]);
var TopicsGoodsListImg = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsGoodsListImg",
  componentId: "sc-10alucx-11"
})(["width:100%;margin:0 auto;margin-top:30px;"]);
var TopicsImgRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsImgRemark",
  componentId: "sc-10alucx-12"
})(["font-size:12px;color:#333;margin-top:8px;"]);
var TopicsSales = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSales",
  componentId: "sc-10alucx-13"
})(["width:100%;margin-top:50px;overflow:hidden;@media screen and (max-width:1040px){margin-top:30px;}"]);
var TopicsSalesList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSalesList",
  componentId: "sc-10alucx-14"
})(["width:350px;float:left;@media screen and (max-width:1040px){width:100%;max-width:350px;}"]);
var TopicsSalesListRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSalesListRemark",
  componentId: "sc-10alucx-15"
})(["float:left;margin-left:30px;font-size:17px;line-height:40px;span{font-weight:bold;}@media screen and (max-width:1040px){width:100% !important;margin-left:0;margin-top:10px;font-size:14px;p{line-height:24px;}}"]);
var TopicsSalesListRemarkTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSalesListRemarkTit",
  componentId: "sc-10alucx-16"
})(["font-size:24px;font-weight:bold;margin-bottom:20px;margin-top:5px;@media screen and (max-width:1040px){font-size:18px;margin-bottom:0;}"]);
var TopicsSalesListImg = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsSalesListImg",
  componentId: "sc-10alucx-17"
})(["max-width:350px;width:100%;margin:0 auto;"]);
var SeyuTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeyuTit",
  componentId: "sc-10alucx-18"
})(["overflow:hidden;margin-top:50px;@media screen and (max-width:1040px){margin-top:0px;}"]);
var Seiyu = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__Seiyu",
  componentId: "sc-10alucx-19"
})(["overflow:hidden;margin-top:20px;"]);
var SeyuTitLogo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeyuTitLogo",
  componentId: "sc-10alucx-20"
})(["overflow:hidden;float:left;img{width:170px;}@media screen and (max-width:1040px){margin-top:30px;img{width:100px;}}"]);
var SeyuTitRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeyuTitRemark",
  componentId: "sc-10alucx-21"
})(["font-size:16px;font-weight:bold;float:left;margin-left:58px;margin-top:9px;span{font-size:24px;}@media screen and (max-width:1040px){font-size:14px;span{font-size:15px;};margin-top:20px;margin-left:0;}"]);
var SeiyuLeft = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeft",
  componentId: "sc-10alucx-22"
})(["width:530px;float:left;@media screen and (max-width:1040px){width:100%;}"]);
var SeiyuLeftCompany = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftCompany",
  componentId: "sc-10alucx-23"
})(["text-align:center;font-size:20px;font-weight:bold;color:#FFF;background:#C00000;line-height:28px;@media screen and (max-width:1040px){font-size:16px;line-height:26px;}"]);
var SeiyuLeftInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfo",
  componentId: "sc-10alucx-24"
})(["border:1px solid #C00000;overflow:hidden;"]);
var SeiyuLeftInfoCompany = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoCompany",
  componentId: "sc-10alucx-25"
})(["float:left;width:45%;@media screen and (max-width:1040px){width:100%;}"]);
var SeiyuLeftInfoLine = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoLine",
  componentId: "sc-10alucx-26"
})(["overflow:hidden;font-size:16px;font-weight:bold;margin-top:15px;"]);
var SeiyuLeftInfoLineBottom = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoLineBottom",
  componentId: "sc-10alucx-27"
})(["overflow:hidden;font-size:16px;font-weight:bold;@media screen and (max-width:1040px){margin-top:15px;}"]);
var SeiyuLeftInfoLineKey = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoLineKey",
  componentId: "sc-10alucx-28"
})(["margin-left:15px;width:80px;float:left;@media screen and (max-width:1040px){width:80px;}"]);
var SeiyuLeftInfoLineValue = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoLineValue",
  componentId: "sc-10alucx-29"
})(["float:left;font-size:14px;font-weight:normal;"]);
var SeiyuLeftInfoTwoLineValue = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoTwoLineValue",
  componentId: "sc-10alucx-30"
})(["width:55%;float:left;font-size:14px;font-weight:normal;line-height:16px;@media screen and (max-width:1040px){width:52%;}"]);
var SeiyuLeftInfoRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuLeftInfoRemark",
  componentId: "sc-10alucx-31"
})(["clear:both;width:95%;font-size:11px;padding-top:10px;text-align:right;margin-bottom:8px;@media screen and (max-width:1040px){text-align:center;width:100%;}"]);
var SeiyuRightInfoMember = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRightInfoMember",
  componentId: "sc-10alucx-32"
})(["float:left;width:55%;@media screen and (max-width:1040px){width:100%;}"]);
var SeiyuMapStore = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapStore",
  componentId: "sc-10alucx-33"
})(["overflow:hidden;"]);
var SeiyuMap = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMap",
  componentId: "sc-10alucx-34"
})(["width:280px;overflow:hidden;float:left;@media screen and (max-width:1040px){width:100%;float:none;}"]);
var SeiyuMapInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapInfo",
  componentId: "sc-10alucx-35"
})(["width:280px;overflow:hidden;margin:0 auto;position:relative;margin-top:7px;img{width:280px;}@media screen and (max-width:1040px){font-size:16px;line-height:22px;width:auto;max-width:280px;img{width:100%;max-width:280px;}}"]);
var SeiyuMapRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemark",
  componentId: "sc-10alucx-36"
})(["width:150px;position:absolute;top:0;left:0;"]);
var SeiyuMapRemarkLogo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkLogo",
  componentId: "sc-10alucx-37"
})(["img{width:40px;}"]);
var SeiyuMapRemarkLine = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkLine",
  componentId: "sc-10alucx-38"
})(["font-size:12px;line-height:16px;font-weight:bold;padding-top:8px;padding-bottom:8px;margin-top:6px;border-top:1px solid #BFBFBF;border-bottom:1px solid #BFBFBF;@media screen and (max-width:1040px){margin-top:3px;}"]);
var SeiyuMapRemarkList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkList",
  componentId: "sc-10alucx-39"
})(["overflow:hidden;"]);
var SeiyuMapRemarkListKey = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkListKey",
  componentId: "sc-10alucx-40"
})(["width:42%;text-align:center;float:left;"]);
var SeiyuMapRemarkListValue = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkListValue",
  componentId: "sc-10alucx-41"
})(["width:58%;text-align:center;float:left;"]);
var SeiyuMapRemarkTotal = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkTotal",
  componentId: "sc-10alucx-42"
})(["overflow:hidden;margin-top:10px;font-weight:bold;color:#C00000;"]);
var SeiyuMapRemarkTotalKey = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkTotalKey",
  componentId: "sc-10alucx-43"
})(["width:34%;text-align:center;float:left;"]);
var SeiyuMapRemarkTotalValue = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuMapRemarkTotalValue",
  componentId: "sc-10alucx-44"
})(["width:66%;text-align:center;float:left;"]);
var SeiyuStore = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStore",
  componentId: "sc-10alucx-45"
})(["width:232px;overflow:hidden;float:right;@media screen and (max-width:1040px){width:100%;float:none;}"]);
var SeiyuStoreList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreList",
  componentId: "sc-10alucx-46"
})(["width:220px;overflow:hidden;margin:0 auto;margin-top:20px;@media screen and (max-width:1040px){width:80%;}"]);
var SeiyuStoreListTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListTit",
  componentId: "sc-10alucx-47"
})(["line-height:40px;font-size:16px;color:#C00000;text-align:center;overflow:hidden;@media screen and (max-width:1040px){font-size:14px;line-height:22px;}"]);
var SeiyuStoreListLeft = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListLeft",
  componentId: "sc-10alucx-48"
})(["width:110px;float:left;text-align:center;font-weight:bold;"]);
var SeiyuStoreListRight = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListRight",
  componentId: "sc-10alucx-49"
})(["width:100px;float:right;text-align:center;font-weight:bold;"]);
var SeiyuStoreListImg = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListImg",
  componentId: "sc-10alucx-50"
})(["overflow:hidden;padding-bottom:10px;bottom:1px solid #BFBFBF;@media screen and (max-width:1040px){font-size:14px;line-height:22px;}"]);
var SeiyuStoreListTitLeft = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListTitLeft",
  componentId: "sc-10alucx-51"
})(["width:110px;float:left;position:relative;img{width:100%;}@media screen and (max-width:1040px){font-size:14px;line-height:22px;}"]);
var SeiyuStoreListTitRight = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListTitRight",
  componentId: "sc-10alucx-52"
})(["width:100px;float:right;position:relative;img{width:100%;}@media screen and (max-width:1040px){font-size:14px;line-height:22px;}"]);
var SeiyuStoreListImgRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListImgRemark",
  componentId: "sc-10alucx-53"
})(["width:56px;height:22px;right:2px;bottom:2px;background:#FFF;line-height:10px;margin-top:1px;text-align:center;font-size:8px;position:absolute;img{width:100%;}p{font-weight:bold;}span{font-weight:bold;font-size:10px;}"]);
var SeiyuStoreListInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListInfo",
  componentId: "sc-10alucx-54"
})(["line-height:34px;position:relative;border-top:1px solid #BFBFBF;border-bottom:1px solid #BFBFBF;overflow:hidden;font-size:13px;"]);
var SeiyuStoreListArea = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuStoreListArea",
  componentId: "sc-10alucx-55"
})(["line-height:34px;overflow:hidden;font-size:13px;"]);
var SeiyuRight = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRight",
  componentId: "sc-10alucx-56"
})(["width:485px;float:right;@media screen and (max-width:1040px){width:100%;}"]);
var SeiyuRightTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRightTit",
  componentId: "sc-10alucx-57"
})(["font-size:24px;width:210px;text-align:center;margin:0 auto;background:#FFF;font-weight:bold;position:relative;z-index:1;@media screen and (max-width:1040px){width:100%;font-size:16px;margin-top:35px;width:160px;}"]);
var SeiyuRightBorder = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRightBorder",
  componentId: "sc-10alucx-58"
})(["border:1px solid #7A7A7A;padding-left:17px;padding-right:17px;padding-top:5px;margin-top:-12px;@media screen and (max-width:1040px){margin-top:-8px;}"]);
var SeiyuRightSelect = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRightSelect",
  componentId: "sc-10alucx-59"
})(["font-size:18px;margin-top:25px;color:#C00000;font-weight:bold;@media screen and (max-width:1040px){font-size:14px;}"]);
var SeiyuRightSelectRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuRightSelectRemark",
  componentId: "sc-10alucx-60"
})(["font-size:16px;line-height:22px;margin-top:5px;@media screen and (max-width:1040px){font-size:12px;line-height:18px;margin-top:3px;}"]);
var SeiyuDevelopment = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__SeiyuDevelopment",
  componentId: "sc-10alucx-61"
})(["width:100%;height:auto;margin-top:20px;margin-bottom:40px;@media screen and (max-width:767px){height:auto;overflow:auto;margin-top:20px;img{width:auto;height:auto;}}"]);
var TopicsDevelop = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelop",
  componentId: "sc-10alucx-62"
})(["overflow:hidden;margin-top:20px;"]);
var TopicsDevelopLeft = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopLeft",
  componentId: "sc-10alucx-63"
})(["width:500px;float:left;@media screen and (max-width:1040px){width:100%;}"]);
var TopicsDevelopLeftTitle = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopLeftTitle",
  componentId: "sc-10alucx-64"
})(["text-align:center;font-size:20px;font-weight:bold;color:#FFF;background:", ";line-height:44px;@media screen and (max-width:1040px){font-size:16px;line-height:32px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsDevelopLeftInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopLeftInfo",
  componentId: "sc-10alucx-65"
})(["border:1px solid ", ";overflow:hidden;padding:20px 30px;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var TopicsDevelopLeftRemark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopLeftRemark",
  componentId: "sc-10alucx-66"
})(["font-size:18px;font-weight:bold;text-align:center;line-height:22px;span{color:#FF0000;}@media screen and (max-width:767px){font-size:14px;line-height:20px;}"]);
var TopicsDevelopLeftImg = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopLeftImg",
  componentId: "sc-10alucx-67"
})(["max-width:350px;width:100%;margin:0 auto;margin-top:20px;"]);
var TopicsDevelopRight = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopRight",
  componentId: "sc-10alucx-68"
})(["width:510px;float:right;@media screen and (max-width:1040px){width:100%;}"]);
var TopicsDevelopRightTit = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopRightTit",
  componentId: "sc-10alucx-69"
})(["line-height:42px;font-size:20px;font-weight:bold;border-bottom:3px solid #333;@media screen and (max-width:1040px){width:100%;font-size:16px;}"]);
var TopicsDevelopRightInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopRightInfo",
  componentId: "sc-10alucx-70"
})(["display:flex;gap:30px;@media screen and (max-width:1040px){width:100%;font-size:16px;display:block;}"]);
var TopicsDevelopRightInfoFlex = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsDevelopRightInfoFlex",
  componentId: "sc-10alucx-71"
})(["padding-top:11px;flex:1;text-align:center;div{text-align:left;margin-top:12px;font-size:16px;font-weight:bold;span{margin-right:15px;}}img{margin-top:12px;width:auto;max-width:100%;max-height:131px;}@media screen and (max-width:1040px){img{width:100%;height:auto;max-height:300px;}}"]);
var TopicsImg24Remark = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "topics-cocotora2025__TopicsImg24Remark",
  componentId: "sc-10alucx-72"
})(["margin-top:40px;font-size:12px;margin-bottom:50px;@media screen and (max-width:1040px){margin-top:20px;}"]);
var TopicsImg24RemarkInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "topics-cocotora2025__TopicsImg24RemarkInfo",
  componentId: "sc-10alucx-73"
})(["margin:0;padding-left:16px;text-indent:-16px;white-space:normal;word-wrap:break-word;line-height:16px;"]);
var TopicsImg24RemarkInfoTxt = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "topics-cocotora2025__TopicsImg24RemarkInfoTxt",
  componentId: "sc-10alucx-74"
})(["margin-left:16px;padding-left:16px;text-indent:-16px;white-space:normal;word-wrap:break-word;line-height:16px;"]);

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 44221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail-investor/topics-cocotora2025",
      function () {
        return __webpack_require__(26639);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,2167,5548,9774,2888,179], function() { return __webpack_exec__(44221); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);